import { Font } from './'


export const Brand = {
  fontSize: '2.475rem',
  lineHeight: '1.2em',
  fontWeight: 100,
  fontFamily: Font.base,
  '@media (min-width: 1024px)': {
    fontSize: '8.25rem',
  }
}

// Title H1
export const H1 = {
  fontSize: '2.4rem',
  lineHeight: '1em',
  textTransform: 'uppercase',
  fontFamily: `${Font.title}, sans-serif`,
  '@media (min-width: 1024px)': {
    fontSize: '4.8125rem',
  }
}

// Title H1
export const H2 = {
  fontSize: '2rem',
  lineHeight: '1em',
  textTransform: 'uppercase',
  fontFamily: `${Font.title}, sans-serif`,
  fontWeight: 'bold',
  '@media (min-width: 1024px)': {
    fontSize: '3.3rem',
  }
}


export const Subtitle = {
  fontWeight: 100,
  fontSize: '2rem',
  fontFamily: `${Font.base}, sans-serif`,
  '@media (min-width: 1024px)': {
    fontSize: '2.5rem',
  }
}

export const Link = {
  fontSize: '0.825rem',
  lineHeight: '1.2em',
  textTransform: 'uppercase',
  textDecoration: 'none',
  fontFamily: Font.base,
  fontWeight: 800,
  letterSpacing: '0.125rem',
  textIndent: '0.125rem',
}

export const Label = {
  fontSize: '1.325rem',
  fontFamily: Font.base,
  fontWeight: 200,
  '@media (min-width: 1024px)': {
    fontSize: '1.65rem',
  }
}

//Menu 
export const MenuLink = {
  ...Link,
  fontSize: '1rem',
  letterSpacing: 0,
}

//Menu 
export const CardTitle = {
  ...Link,
  fontSize: '1.125rem',
  letterSpacing: '0rem',
  textIndent: '0rem',
  '@media (min-width: 1024px)': {
    letterSpacing: '0.125rem',
    textIndent: '0.125rem',
  }
}

export const MenuH2 = {
  fontSize: '2.5rem',
  fontFamily: Font.title_font,
  fontWeight: 200,
  '@media (min-width: 1024px)': {
    fontSize: '3rem',
  }
}

export const XSmall = {
  ...Link,
  fontSize: '0.6rem',
  letterSpacing: 0,
}

export const ProfileName = {
  fontSize: '1.25rem',
  fontFamily: Font.base,
  fontWeight: 800,
  '@media (min-width: 1224px)': {
    fontSize: '0.9375rem',
  }
}

export const PushTitle = {
  fontSize: '2rem',
  fontFamily: Font.base,
  fontWeight: 800,
  lineHeight: 1.2,
  letterSpacing: '0.125rem',
  '@media (min-width: 1224px)': {
    fontSize: '2.5rem',
  }
}

export const SearchLabel = {
  fontSize: '1.25rem',
  fontFamily: Font.base,
  fontWeight: 200,
  lineHeight: 1.2,
  '@media (min-width: 1024px)': {
    fontSize: '3.3rem',
    letterSpacing: '0.125rem',
  }
}

// 13px
export const SliderLabel = {
  fontSize: '0.8125rem',
  fontFamily: Font.base,
  lineHeight: 1.2,
  fontWeight: 800,
  textTransform: 'uppercase'
} 

// SLIDER
export const SliderTitle = {
  fontSize: '2.8125rem',
  fontFamily: Font.title,
  lineHeight: 1.2,
  fontWeight: 'bold',
  textTransform: 'uppercase',
  marginBottom: '2rem',

  '@media (min-width: 1024px)':{
    fontSize: '4.375rem',
    marginBottom: '4rem',
  }
}

export const SliderContent = {
  fontSize: '1.125rem',
  fontFamily: Font.base,
  lineHeight: 1.4,
}

export const SliderSubtitle = {
  fontSize: '1.625rem',
  fontFamily: Font.base,
  lineHeight: 1.2,
  fontWeight: 'bold',
  '@media (min-width: 1024px)':{
    fontSize: '2.5rem',
  }
}
export const SliderDescription = {
  fontSize: '1rem',
  fontFamily: Font.base,
  lineHeight: 1.2,
  fontWeight: 400,
}

export const CardSmall = {
  fontSize: '0.8125rem',
  fontFamily: Font.base,
  lineHeight: 1.2,
}


export const SubtitlePage = {
  fontSize: '1.875rem',
  fontFamily: Font.base,
  lineHeight: 1.2,
  textTransform: 'uppercase',
  fontWeight: 'bold',
}


// WEBPACK FOOTER //
// ./src/styles/typo.js